import gql from 'graphql-tag'

const utente = gql`
  query utente(
    $where: UtenteFilterInput
    $appuntamentiWhere: AzioniFilterInput
    $assenzeWhere: AssenzeFilterInput
  ) {
    utente(
      where: $where
    ) {
      id
      nome
      email
      ruolo
      assenze(
        where: $assenzeWhere
      ) {
        id
        utenteId
        utente {
          id
          nome
        }
        daDataOra
        aDataOra
        descrizione
        flagOccupato
      }
      appuntamenti(
        where: $appuntamentiWhere
      ) {
        id
        utenteId
        utente {
          id
          nome
        }
        clienteId
        cliente {
          id
          nome
        }
        offertaId
        offerta {
          id
          nome
        }
        campagnaId
        campagna {
          id
          nome
        }
        tipoAzioneId
        tipoAzione {
          id
          tipo
        }
        appuntamentoAgenteId
        appuntamentoAgente {
          id
          nome
        }
        dataOra
        descrizione
        appuntamentoDaDataOra
        appuntamentoADataOra
        appuntamentoLuogo
        appuntamentoStato
        appuntamentoOrigine
        promemoriaUtenteId
        promemoriaUtente {
          id
          nome
          ruolo
        }
        promemoriaDataOra
        promemoriaDismesso
        votoAgente
        flagSondaggioInviato
      }
    }
  }
`

export default utente


// WEBPACK FOOTER //
// ./src/graphql/queries/utente.js